// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__sQco1","second":"return_second__1RKUE","link":"return_link__1QWSV"};